/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-25 12:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import QuickViewPreview from './quick-view-preview';
import AjaxCartPreview from './ajax-cart-preview';
import FeLibPreview from './felib-preview';

// import { ELEMENTS } from 'src/constants/theme-settings';
import { MENU_ID } from 'src/constants/theme-settings.jsx';

type Props = {
  activeMenuItem: string,
  formValues: any,
  tenantApp: any,
  themeId: string | number,
  themeName: string,
  selectedPage: string,
  previewSetting: any,
  previewProductData: any,
  device: number,
  isExpandFullscreen: boolean,
  labelTranslation: any,
  primaryLocale: string,
  currency: string,
  country: string,
  boostThemeLib: string,
  boostThemeLibVersion: string,
  themeSettingDefaultValue: any,
};

type ComposedProps = Props & WithI18nProps;

class GeneralPreview extends Component<ComposedProps> {
  getSpecificPreview = () => {
    const { activeMenuItem } = this.props;
    const MappingPreview = {
      [MENU_ID.QUICK_VIEW]: QuickViewPreview,
      [MENU_ID.AJAX_CART]: AjaxCartPreview
    };

    const ComponentPreview = MappingPreview[activeMenuItem];
    return ComponentPreview;
  };

  render() {
    const {
      activeMenuItem,
      formValues,
      tenantApp,
      themeName,
      themeId,
      themeInfo,
      selectedPage,
      previewSetting,
      previewProductData,
      device,
      isExpandFullscreen,
      labelTranslation,
      primaryLocale,
      currency,
      country,
      boostThemeLib,
      boostThemeLibVersion,
      themeSettingDefaultValue,
    } = this.props;
    const SpecificPreview = this.getSpecificPreview();

    const hasFELibPreview = _.get(tenantApp, 'settings.FELibPreview.settings.enable', false);
    const settingVersion = _.get(tenantApp, 'settings.FELibPreview.settings.version', '');
    let version = process.env.REACT_APP_BOOST_CDN_FOLDER;

    if (process.env.REACT_APP_ENV === 'production') {
      version = boostThemeLibVersion;
    }
    // Use theme lib version setting if have
    if (hasFELibPreview && !_.isEmpty(settingVersion)) {
      version = settingVersion;
    }

    const taeFeatures = {
      ..._.get(themeInfo, 'taeFeatures', {}),
      filterCollection: 'installed',
      filterSearch: 'installed',
      instantSearch: 'not-installed'
    };

    return (
      <>
        <FeLibPreview
          prefix={activeMenuItem}
          formValues={formValues}
          tenantApp={tenantApp}
          themeName={themeName}
          themeId={themeId}
          taeFeatures={taeFeatures}
          version={version}
          selectedPage={selectedPage}
          previewSetting={previewSetting}
          labelTranslation={labelTranslation}
          // preventLoading={!!SpecificPreview}
          device={device}
          primaryLocale={primaryLocale}
          currency={currency}
          country={country}
          boostThemeLib={boostThemeLib}
          boostThemeLibVersion={boostThemeLibVersion}
          themeSettingDefaultValue={themeSettingDefaultValue}
        />
        {SpecificPreview && (
          <SpecificPreview
            prefix={activeMenuItem}
            formValues={formValues}
            previewProductData={previewProductData}
            device={device}
            labelTranslation={labelTranslation}
            isExpandFullscreen={isExpandFullscreen}
          />
        )}
      </>
    );
  }
}

export default withI18n()(GeneralPreview);
